import React from "react";
import Logo from "../assets/image/Logo.png";
import { routes } from "../contant";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/navbar";
import Footur from "../components/footur";

const ProLeadPartnerAgreement = () => {
  const navigate = useNavigate();
  const handleAgree = () => {
    navigate("/Account"); // Navigate to the Account page
  };
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <Navbar />
      <div className='flex justify-center py-4 px-4 sm:px-6 lg:px-8'>
      <div className='w-full max-w-[90%] sm:max-w-4xl bg-white rounded-2xl p-4 sm:p-6'>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-[#1E90FF] flex items-center justify-center gap-2">
            Pro Lead Partner Agreement 📜
          </h1>

          <p className="mt-4 text-gray-700">
            This agreement is entered into by and between <b>LeadGenPro</b>{" "}
            ("The Platform") and the individual/entity registering as a{" "}
            <b>Pro Lead Partner</b> ("The Partner").<br></br>
          </p>
          <h2>
            
            <b>Terms and Conditions for Pro Lead Partners</b>
            <br></br>
            By signing up as a Pro Lead Partner on LeadGenPro, you agree to the
            following terms and conditions:
          </h2>

          <h2 className='text-lg sm:text-xl font-semibold text-[#1E90FF]'>
              1️⃣  Introduction
            </h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
              {" "}
              This agreement outlines the terms and conditions under which The Partner will generate leads for 
motor insurance through The Platform and earn activity points as compensation
            </li>
            <br></br>
            <li>
              The Partner agrees to abide by the laws, rules, and regulations
              applicable under the Insurance Act, 1938, IRDAI Guidelines, and
              Income Tax Act, 1961.
            </li>
          </ul>

          <h2 className='text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4'>
              2️⃣ Role Of Partner 👥
          </h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
              The Partner’s role is limited to submitting genuine leads and
              assisting customers with insurance policy purchases through The
              Platform.
            </li>
            <li>
              The Partner shall not issue policies, act as an insurance broker,
              or represent themselves as an insurance advisor.
            </li>
            <li>
              All communication with customers must be in compliance with IRDAI
              guidelines.
            </li>
          </ul>

          <h2 className='text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4'>
              3️⃣ Lead Submission and Approval ✅
          </h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
              The Partner will submit leads including customer details (vehicle
              registration, make/model, year, and previous policy details)
            </li>
            <li>
              All leads will be verified by The Platform. Only verified and
              genuine leads will be eligible for activity points.
            </li>
            <li>
              The Partner must ensure data confidentiality and security when
              collecting customer information.
            </li>
          </ul>

          <h2 className='text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4'>
              4️⃣Activity Points Structure 🎯
          </h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
              The Partner will earn 5%-15% of the premium amount (excluding
              taxes) as activity points for each policy successfully purchased.
            </li>
           
            <li>
              The exact percentage for activity points will depend on the type
              of policy and insurance provider, as determined by The Platform.
            </li>
          </ul>

          <h2 className='text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4'>
              5️⃣ Payout Schedule 💰</h2>
          <ul className="list-disc pl-5 text-gray-700">
            <p> Payouts will be processed twice a month:</p>
            <li>
              For policies issued between 1st-15th, the payout will be made on
              the 17th of the month
            </li>
            <li>
              For policies issued between 16th-30th, the payout will be made on
              the 2nd of the following 
            </li>
            Payouts will be transferred to The Partner’s registered bank account
            after applicable TDS deductions.
          </ul>

          <h2 className='text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4'>
              6️⃣ Compliance with Laws ⚖️
          </h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
              The Platform operates as a lead generation platform and adheres to
              all relevant provisions of the Insurance Act, 1938.
            </li>
            <li>
              All policies are issued through licensed POSP providers, ensuring
              compliance with IRDAI Guidelines.
            </li>
            <li>
              The Partner is responsible for their tax obligations under the
              Income Tax Act, 1961.
            </li>
          </ul>

          <h2 className='text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4'>
          7️⃣Termination ❌</h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
              The Platform reserves the right to terminate this agreement if The
              Partner is found to violate any terms of this agreement or
              applicable laws.
            </li>
            <li>
              Upon termination, all pending activity points and payouts may be
              forfeited at the discretion of The Platform.
            </li>
          </ul>

          <h2 className='text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4'>
          8️⃣ Confidentiality and Security 🔒
          </h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
              The Partner must ensure that customer data is collected, stored,
              and shared securely.
            </li>
            <li>
              Any misuse of data will result in immediate termination and
              possible legal action..
            </li>
          </ul>

          <h2 className='text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4'>
  9️⃣
Dispute Resolution ⚖️
          </h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
              {" "}
              Any disputes arising under this agreement will be resolved
              amicably through discussion..
            </li>
            <li>
              If unresolved, disputes will be subject to the jurisdiction of the
              courts where The Platform is registered..
            </li>
          </ul>
          <h3>
            By clicking “I Agree,” you acknowledge that you have read,
            understood, and agree to abide by the terms and conditions outlined
            above.
          </h3>
          <div className="text-center mt-6">
            <button className="bg-blue-600 text-white px-6 py-2 rounded-full shadow-md hover:bg-blue-700 transition"
            
            onClick={handleAgree}>
              I Agree ✅
            </button>
          </div>
        </div>
      </div>

      
    </div>
  );
};

export default ProLeadPartnerAgreement;
